var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokAudience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 99,
    viewBox: "0 0 60 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5644_6194)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.98492,
    y: 0.984921,
    width: 53.1214,
    height: 91.5542,
    rx: 5.40317,
    fill: "white",
    stroke: "#26245B",
    strokeWidth: 0.469841
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 35.0664V30.3331C39.0333 30.3331 37.3417 29.7414 36.25 28.5914C35.1296 27.2789 34.5019 25.6169 34.475 23.8914V23.5497L30 23.4414V42.6664C29.8465 43.5052 29.4393 44.2767 28.8335 44.8768C28.2276 45.4768 27.4522 45.8766 26.612 46.022C25.7717 46.1674 24.9071 46.0515 24.1348 45.6899C23.3625 45.3284 22.7197 44.7386 22.2933 44.0002C21.8668 43.2618 21.6772 42.4103 21.7499 41.5606C21.8227 40.711 22.1545 39.9042 22.7003 39.2491C23.2462 38.594 23.9799 38.1221 24.8025 37.8972C25.625 37.6723 26.4967 37.7052 27.3 37.9914V33.4081C26.8317 33.3313 26.3579 33.2923 25.8833 33.2914C24.1758 33.2914 22.5067 33.7977 21.0869 34.7464C19.6672 35.695 18.5606 37.0434 17.9072 38.6209C17.2537 40.1984 17.0828 41.9343 17.4159 43.609C17.749 45.2837 18.5713 46.822 19.7786 48.0294C20.986 49.2368 22.5244 50.0591 24.1991 50.3922C25.8738 50.7253 27.6096 50.5543 29.1872 49.9009C30.7647 49.2475 32.1131 48.1409 33.0617 46.7212C34.0103 45.3014 34.5167 43.6323 34.5167 41.9247C34.5157 41.5709 34.4935 41.2175 34.45 40.8664V33.2414C36.4849 34.5122 38.8523 35.1476 41.25 35.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 70.75,
    width: 29.2287,
    height: 1.21798,
    rx: 0.565889,
    fill: "#26245B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 72.5781,
    width: 27.4019,
    height: 1.21798,
    rx: 0.565889,
    fill: "#26245B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 74.4043,
    width: 6.08932,
    height: 1.21798,
    rx: 0.565889,
    fill: "#26245B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9434,
    y: 87.1992,
    width: 4.79108,
    height: 3.72639,
    rx: 0.851748,
    fill: "#E6436D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0117,
    y: 87.1992,
    width: 4.79108,
    height: 3.72639,
    rx: 0.851748,
    fill: "#65D2E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4766,
    y: 87.1992,
    width: 4.79108,
    height: 3.72639,
    rx: 0.851748,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7731 88.2305C27.7363 88.2305 27.7065 88.2603 27.7065 88.297V88.9292H27.0744C27.0376 88.9292 27.0078 88.959 27.0078 88.9957V89.1953C27.0078 89.2321 27.0376 89.2619 27.0744 89.2619H27.7065V89.894C27.7065 89.9308 27.7363 89.9606 27.7731 89.9606H27.9727C28.0094 89.9606 28.0392 89.9308 28.0392 89.894V89.2619H28.6714C28.7081 89.2619 28.7379 89.2321 28.7379 89.1953V88.9957C28.7379 88.959 28.7081 88.9292 28.6714 88.9292H28.0392V88.297C28.0392 88.2603 28.0094 88.2305 27.9727 88.2305H27.7731Z",
    fill: "#161722"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86048 87.0231C5.82347 86.9923 5.7697 86.9923 5.73268 87.0231L4.29815 88.2186C4.20253 88.2983 4.25888 88.4539 4.38335 88.4539H4.60206L4.65596 89.5319C4.66304 89.6735 4.77996 89.7848 4.9218 89.7848H5.56368C5.61881 89.7848 5.6635 89.7401 5.6635 89.6849V88.8532C5.6635 88.8164 5.69329 88.7866 5.73004 88.7866H5.86313C5.89988 88.7866 5.92967 88.8164 5.92967 88.8532V89.6849C5.92967 89.7401 5.97436 89.7848 6.02948 89.7848H6.67137C6.81321 89.7848 6.93013 89.6735 6.93721 89.5319L6.99111 88.4539H7.20982C7.33429 88.4539 7.39064 88.2983 7.29502 88.2186L5.86048 87.0231Z",
    fill: "#26245B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4104 89.1576C17.2106 89.307 16.9626 89.3955 16.6939 89.3955C16.0324 89.3955 15.4961 88.8593 15.4961 88.1978C15.4961 87.5363 16.0324 87 16.6939 87C17.3554 87 17.8916 87.5363 17.8916 88.1978C17.8916 88.4946 17.7836 88.7663 17.6048 88.9756L18.1966 89.5674C18.2226 89.5934 18.2226 89.6356 18.1966 89.6615L18.1025 89.7556C18.0765 89.7816 18.0344 89.7816 18.0084 89.7556L17.4104 89.1576ZM17.6255 88.1978C17.6255 88.7123 17.2084 89.1294 16.6939 89.1294C16.1794 89.1294 15.7623 88.7123 15.7623 88.1978C15.7623 87.6833 16.1794 87.2662 16.6939 87.2662C17.2084 87.2662 17.6255 87.6833 17.6255 88.1978Z",
    fill: "#26245B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4529 88.1995C38.4162 88.1995 38.3864 88.2292 38.3864 88.266V88.3991C38.3864 88.4358 38.4162 88.4656 38.4529 88.4656H39.3845C39.4213 88.4656 39.4511 88.4358 39.4511 88.3991V88.266C39.4511 88.2292 39.4213 88.1995 39.3845 88.1995H38.4529Z",
    fill: "#26245B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8541 87.1348C37.7071 87.1348 37.5879 87.2539 37.5879 87.4009V89.1311C37.5879 89.2781 37.7071 89.3972 37.8541 89.3972H38.4583L38.8173 89.8199C38.8705 89.8825 38.967 89.8825 39.0202 89.8199L39.3792 89.3972H39.9834C40.1304 89.3972 40.2496 89.2781 40.2496 89.1311V87.4009C40.2496 87.2539 40.1304 87.1348 39.9834 87.1348H37.8541ZM37.8541 89.1311V87.4009H39.9834V89.1311H39.3185C39.2794 89.1311 39.2422 89.1483 39.2169 89.1781L38.9187 89.5303L38.6206 89.1781C38.5953 89.1483 38.5581 89.1311 38.519 89.1311H37.8541Z",
    fill: "#26245B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6786 87.7652C50.6786 88.1879 50.336 88.5305 49.9133 88.5305C49.4907 88.5305 49.1481 88.1879 49.1481 87.7652C49.1481 87.3426 49.4907 87 49.9133 87C50.336 87 50.6786 87.3426 50.6786 87.7652ZM50.4124 87.7652C50.4124 88.0409 50.189 88.2643 49.9133 88.2643C49.6377 88.2643 49.4143 88.0409 49.4143 87.7652C49.4143 87.4896 49.6377 87.2662 49.9133 87.2662C50.189 87.2662 50.4124 87.4896 50.4124 87.7652Z",
    fill: "#26245B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7039 89.6248C48.6939 89.6575 48.7122 89.6917 48.7442 89.7033L48.8684 89.7485C48.9061 89.7623 48.9472 89.7397 48.9589 89.7013C49.0842 89.2931 49.4641 88.9963 49.9133 88.9963C50.3626 88.9963 50.7425 89.2931 50.8677 89.7013C50.8795 89.7397 50.9205 89.7623 50.9582 89.7485L51.0824 89.7033C51.1145 89.6917 51.1327 89.6575 51.1228 89.6248C50.9647 89.1069 50.483 88.7301 49.9133 88.7301C49.3437 88.7301 48.862 89.1069 48.7039 89.6248Z",
    fill: "#26245B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6691 55.2023C51.6691 56.8412 50.3406 58.1697 48.702 58.1697C47.0633 58.1697 45.7349 56.8412 45.7349 55.2023C45.7349 53.5634 47.0633 52.2349 48.702 52.2349C50.3406 52.2349 51.6691 53.5634 51.6691 55.2023Z",
    stroke: "#26245B",
    strokeWidth: 0.469841
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5644_6194",
    x: 0.232051,
    y: 0.75,
    width: 59.6636,
    height: 98.0952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.51795,
    dy: 3.0359
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5644_6194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5644_6194",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokAudience);
export default __webpack_public_path__ + "static/media/tiktokAudience.cfaab0278bef915373f73102e09f6a30.svg";
export { ForwardRef as ReactComponent };